import { formatDuration } from 'date-fns'
import i18nInstance from 'i18n/i18nInstance'

const t = i18nInstance.getFixedT(null, '@mc/next')

const s = 60
const h = s * 60
const getHours = (time: number) => Math.floor(time / h)
const getMinutes = (time: number) => Math.floor((time % h) / s)

export const formattedDuration = (durationSeconds: number) =>
  formatDuration({
    hours: getHours(durationSeconds),
    minutes: getMinutes(durationSeconds),
  })

export const isSeriesTile = (link: string) => !!link?.includes('/series/')
export const isSessionsTile = (link: string) => !!link?.includes('/sessions/')

export const getDuration = (link: string, durationOrContentCount: number) => {
  if (isSeriesTile(link))
    return t('home.trendingCarousel.episodes', {
      numEpisodes: durationOrContentCount,
    })
  if (isSessionsTile(link))
    return t('home.trendingCarousel.projects', {
      numProjects: durationOrContentCount,
    })

  return formattedDuration(durationOrContentCount)
}
